// src/api/users.js
import { CONFIG } from '../config/config';

function authHeaders() {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    Authorization: token ? `Bearer ${token}` : '',
  };
}

export async function listUsers() {
  const r = await fetch(`${CONFIG.API_URL}/users`, { headers: authHeaders() });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return r.json();
}

export async function listUsers2() {
  const r = await fetch(`${CONFIG.API_URL}/users/users`, { headers: authHeaders() });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return r.json();
}

export async function listDefaultGroups(id) {
  const r = await fetch(`${CONFIG.API_URL}/profiles/defaultGroup/${id}`, {
    headers: authHeaders(),
  });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return r.json();
}

export async function createUser(payload) {
  const r = await fetch(`${CONFIG.API_URL}/users`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}

export async function createUser2(payload) {
  const r = await fetch(`${CONFIG.API_URL}/users/users`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}

export async function listProfiles() {
  const r = await fetch(`${CONFIG.API_URL}/users/profiles`, { headers: authHeaders() });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return r.json();
}
export async function createProfile(payload) {
  const r = await fetch(`${CONFIG.API_URL}/users/profiles`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}

export async function updateProfile(id, payload) {
  const r = await fetch(`${CONFIG.API_URL}/users/profiles/${id}`, {
    method: 'PATCH',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}

export async function updateProfileSoft(id, payload) {
  const r = await fetch(`${CONFIG.API_URL}/profiles/${id}`, {
    method: 'PATCH',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}

export async function updateUser(id, payload) {
  const r = await fetch(`${CONFIG.API_URL}/users/${id}`, {
    method: 'PATCH',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}

export async function updateUser2(id, payload) {
  const r = await fetch(`${CONFIG.API_URL}/users/users/${id}`, {
    method: 'PATCH',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}

export async function deleteUser(id) {
  const r = await fetch(`${CONFIG.API_URL}/users/${id}`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}

export async function addProfileToUser(id, payload) {
  const r = await fetch(`${CONFIG.API_URL}/users/userProfiles/${id}`, {
    method: 'PATCH',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}

export async function createAdmin(payload) {
  const r = await fetch(`${CONFIG.API_URL}/users/admins`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}

export async function updateAdmin(id, payload) {
  const r = await fetch(`${CONFIG.API_URL}/users/admins/${id}`, {
    method: 'PATCH',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}